var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload28V2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0607 17.5607C14.4749 18.1464 13.5251 18.1464 12.9394 17.5607L7.93935 12.5607C7.35356 11.9749 7.35356 11.0251 7.93935 10.4393C8.52514 9.85355 9.47488 9.85355 10.0607 10.4393L12.5 12.8787V3.5C12.5 2.67157 13.1716 2 14 2C14.8284 2 15.5 2.67157 15.5 3.5V12.8787L17.9394 10.4393C18.5251 9.85355 19.4749 9.85355 20.0607 10.4393C20.6465 11.0251 20.6465 11.9749 20.0607 12.5607L15.0607 17.5607ZM5.50001 16C5.50001 15.1716 4.82844 14.5 4.00001 14.5C3.17158 14.5 2.50001 15.1716 2.50001 16V17.0478L2.50001 17.1529C2.4999 18.4792 2.49981 19.6424 2.65262 20.6119C2.82177 21.6851 3.19008 22.6274 3.97746 23.4718C5.4609 25.0626 7.28083 25.1874 9.46894 25.3374L9.77396 25.3585C11.0011 25.4444 12.4098 25.5 14 25.5C15.5902 25.5 16.9989 25.4444 18.2261 25.3585L18.5311 25.3374C20.7192 25.1874 22.5391 25.0626 24.0226 23.4718C24.8099 22.6274 25.1782 21.6851 25.3474 20.6119C25.5002 19.6424 25.5001 18.4791 25.5 17.1529L25.5 17.0478V16C25.5 15.1716 24.8284 14.5 24 14.5C23.1716 14.5 22.5 15.1716 22.5 16V17.0478C22.5 18.5102 22.4958 19.4355 22.384 20.1448C22.2845 20.7759 22.1156 21.1179 21.8284 21.4258C21.2313 22.0663 20.6649 22.1805 18.0166 22.3658C16.859 22.4468 15.5202 22.5 14 22.5C12.4799 22.5 11.141 22.4468 9.9834 22.3658C7.33512 22.1805 6.76876 22.0663 6.17158 21.4258C5.88445 21.1179 5.7155 20.7759 5.61603 20.1448C5.50424 19.4355 5.50001 18.5102 5.50001 17.0478V16Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload28V2);
export default __webpack_public_path__ + "static/media/download_28_v2.9386bc36.svg";
export { ForwardRef as ReactComponent };